import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors, spacing } = theme.busbud;

  const seat_selection_overlay_height = spacing(20);

  return {
    container: {
      backgroundColor: colors.background.secondary.opaque,
      padding: spacing(2, 3, 3, 3)
    },
    drawerContainer: {
      display: "flex",
      flexDirection: "column",
      // ability to scroll past the seat selection overlay
      paddingBottom: seat_selection_overlay_height
    },
    checkoutDrawerContainer: {
      paddingBottom: spacing(0)
    },
    checkoutDrawerlegend: {
      maxWidth: spacing(40),
      width: "100%"
    },
    legendContainer: {
      alignSelf: "center"
    },
    drawerlegend: {
      margin: spacing(2)
    },
    busContainerAndLegend: {
      overflowX: "auto",
      overflowY: "hidden"
    },
    busContainer: {
      display: "flex",
      alignSelf: "center"
    },
    summaryContainer: {
      maxWidth: spacing(27) // fix the width so that when an alert appears the size does not move
    },
    summaryInline: {
      marginTop: spacing(2)
    }
  };
});
